import React, { Fragment } from 'react';
import { BellIcon, ChevronRightIcon, UserIcon } from 'lucide-react';
interface AdminHeaderProps {
  breadcrumbs: {
    label: string;
    onClick?: () => void;
  }[];
  user?: {
    name: string;
    role: string;
  };
  exhibitorInfo?: {
    name: string;
    standNumber: string;
  };
}
export function AdminHeader({
  breadcrumbs,
  user,
  exhibitorInfo
}: AdminHeaderProps) {
  return <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-8 sticky top-0 z-20" data-id="element-134">
      {/* Left Side - Breadcrumbs */}
      <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-135">
        <div className="flex items-center gap-1.5 text-xs font-gotham min-w-0" data-id="element-136">
          {breadcrumbs.map((crumb, index) => <Fragment key={index} data-id="element-137">
              {index > 0 && <ChevronRightIcon className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" data-id="element-138" />}
              <button onClick={crumb.onClick} disabled={!crumb.onClick} className={`${index === breadcrumbs.length - 1 ? 'font-bold text-gray-900' : 'text-gray-500 hover:text-gray-700'} ${!crumb.onClick ? 'cursor-default' : ''} truncate max-w-[200px]`} title={crumb.label} data-id="element-139">
                {crumb.label}
              </button>
            </Fragment>)}

          {/* Exhibitor Info - Inline after breadcrumbs */}
          {exhibitorInfo && <>
              <div className="h-3 w-px bg-gray-300 mx-1 flex-shrink-0" data-id="element-140"></div>
              <div className="text-xs text-gray-500 truncate max-w-[250px]" title={`${exhibitorInfo.name} • ${exhibitorInfo.standNumber}`} data-id="element-141">
                {exhibitorInfo.name} • {exhibitorInfo.standNumber}
              </div>
            </>}
        </div>
      </div>

      {/* Right Actions */}
      <div className="flex items-center gap-3 flex-shrink-0 ml-4" data-id="element-142">
        <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-full transition-colors relative" data-id="element-143">
          <BellIcon className="w-4 h-4" data-id="element-144" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-145"></span>
        </button>
        <div className="h-6 w-px bg-gray-200 mx-1" data-id="element-146"></div>

        <div className="flex items-center gap-2" data-id="element-147">
          <div className="text-right hidden lg:block" data-id="element-148">
            <div className="text-xs font-bold text-gray-900 font-gotham" data-id="element-149">
              Admin User
            </div>
            <div className="text-[10px] text-gray-500 font-gotham" data-id="element-150">
              Super Admin
            </div>
          </div>
          <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center border border-gray-200" data-id="element-151">
            <UserIcon className="w-4 h-4 text-gray-500" data-id="element-152" />
          </div>
        </div>
      </div>
    </header>;
}